import {Action, ActionsFilter} from '../Actions';
import {StateFilter} from '../State';

// type PartialStateFilter = Pick<StateFilter, keyof StateFilter>;

function setFilter( filter: StateFilter ): Action<typeof ActionsFilter>
{
	return {
		type: ActionsFilter.FILTER$_SET_FILTER,
		payload: {
			...filter,
		},
	};
}

function toggleSection( value: string ): Action<typeof ActionsFilter>
{
	return {
		type: ActionsFilter.FILTER$_TOGGLE_SECTION,
		payload: {
			name: 'section',
			value,
		},
	};
}

function toggleRoomType( value: string ): Action<typeof ActionsFilter>
{
	return {
		type: ActionsFilter.FILTER$_TOGGLE_ROOM_TYPE,
		payload: {
			name: 'roomType',
			value,
		},
	};
}

function setFloorFrom( from: number ): Action<typeof ActionsFilter>
{
	return {
		type: ActionsFilter.FILTER$_SET_FLOOR_FROM,
		payload: {
			name: 'floor',
			from,
		},
	};
}

function setFloorTo( to: number ): Action<typeof ActionsFilter>
{
	return {
		type: ActionsFilter.FILTER$_SET_FLOOR_TO,
		payload: {
			name: 'floor',
			to,
		},
	};
}

function setSquareTotalFrom( from: number ): Action<typeof ActionsFilter>
{
	return {
		type: ActionsFilter.FILTER$_SET_SQUARE_TOTAL_FROM,
		payload: {
			name: 'squareTotal',
			from,
		},
	};
}

function setSquareTotalTo( to: number ): Action<typeof ActionsFilter>
{
	return {
		type: ActionsFilter.FILTER$_SET_SQUARE_TOTAL_TO,
		payload: {
			name: 'squareTotal',
			to,
		},
	};
}

function setTotalCostFrom( from: number ): Action<typeof ActionsFilter>
{
	return {
		type: ActionsFilter.FILTER$_SET_TOTAL_COST_FROM,
		payload: {
			name: 'totalCost',
			from,
		},
	};
}

function setTotalCostTo( to: number ): Action<typeof ActionsFilter>
{
	return {
		type: ActionsFilter.FILTER$_SET_TOTAL_COST_TO,
		payload: {
			name: 'totalCost',
			to,
		},
	};
}

/**
 * Module.
 */
export {
	setFilter,
	toggleSection,
	toggleRoomType,
	setFloorFrom,
	setFloorTo,
	setSquareTotalFrom,
	setSquareTotalTo,
	setTotalCostFrom,
	setTotalCostTo,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/Store/creators/filter.ts